module.exports = __webpack_public_path__ + "img/mufg.c16c1616.svg";